import { LucideProps } from 'lucide-react';
import React from 'react';

type Props = {
  title: string;
  Icon: (props: LucideProps) => React.ReactNode;
};

export default function SectionTitle({ Icon, title }: Props) {
  return (
    <div className="flex items-center gap-2 mb-4">
      <Icon strokeWidth={2.4} size={24} className=" w-6 text-tertiary" />
      <h2 className="text-xl font-semibold text-tertiary">{title}</h2>
    </div>
  );
}
